/* integrations Page Js */
var integrationsJs = function() {
  //Init Scope variables
  var product_slug,
    category_slug,
    focusAfterClosed = null,
    productSelection = document.querySelector(".product-select"),
    sidebar = document.querySelector(".integ-sidebar"),
    inputProductList = document.querySelectorAll(
      ".product-list input[name='product-list']"
    ),
    inputCategoryList = document.querySelectorAll(
      ".category-list input[name='category-list']"
    ),
    websiteHost = window.location.protocol + "//" + window.location.hostname,
    integrationBoxCta,
    paramsValue = {},
    queryStringUTM = "",
    whiteListParams = [
      'utm_source',
      'utm_medium',
      'utm_platform',
      'utm_content',
      'utm_campaign',
      'utm_campaigncode',
      'utm_term'
    ],
    paramsObj = window.location.search
    .slice(1)
    .split('&')
    .map(function (p) {
      return p.split('=');
    })
    .reduce(function (obj, pair) {
      if (pair.length >= 2) {
        obj[pair[0]] = pair[1];
      }
      return obj;
    }, {});

    //Read from cookie
    if (Object.keys(paramsObj).length == 0) {
      var cookieUtmParams = Cookie.read(stage_env_cookie_prefix + "user_utm_data");
      if (cookieUtmParams) {
        paramsObj = bsLib.JSONParse(cookieUtmParams);
      }
    }

    // check white list params
    Object.keys(paramsObj).forEach(function (key) {
      if (whiteListParams.indexOf(key) > -1) {
        paramsValue[key] = paramsObj[key];
      }
    });

  function init() {
    uiBindings();

    getClosestElem();
  }

  function uiBindings() {
    //on load event
    setTimeout(function () {
      loadIntegratonMainPageFunc();
    }, 50);

    //Keyboard event
    var productFocusList = document.querySelectorAll(".product-radio-group label, .category-radio-group label");
    for (var i = 0; i < productFocusList.length; i++) {
      productFocusList[i].addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.keyCode === 13 || event.keyCode === 32) {
          this.click();
        }
      });
    }

    // Add active class to the sidebar for current product based on the url parameter
    if (WPURLS.product_slug) {
      var productSlugInput = document.querySelector(
        ".product-list input[value='" + WPURLS.product_slug + "']"
      );
      if (productSlugInput) {
        productSlugInput.checked = true;
        productSlugInput.classList.add("active");
      }

      // Add active class to the sidebar for current category
      // if category is also selected along with the product
      if (WPURLS.category_slug) {
        var categorySlugInput = document.querySelector(
          ".category-list input[value='" + WPURLS.category_slug + "']"
        );
        if (categorySlugInput) {
          categorySlugInput.checked = true;
          categorySlugInput.classList.add("active");
        }
      }
      productSelection.value = WPURLS.product_slug;
    } else if (WPURLS.category_slug) {
      // if only category is selected
      var categorySlugInput = document.querySelector(
        ".category-list input[value='" + WPURLS.category_slug + "']"
      );
      if (categorySlugInput) {
        categorySlugInput.checked = true;
        categorySlugInput.classList.add("active");
      }
    }

    // Loop through product counts
    if (typeof integrationPageConfig === 'object' && integrationPageConfig.product_count != null) {
      updateIntegrationProductCount(integrationPageConfig.product_count);
    }

    // Loop through categories counts
    if (typeof integrationPageConfig === 'object' && integrationPageConfig.cat_count != null) {
      updateIntegrationCategoryCount(integrationPageConfig.cat_count);
    }

    // Get Integration List based on Product and Category Selection
    if (inputProductList) {
      for (var i = 0; i < inputProductList.length; i++) {
        inputProductList[i].addEventListener("change", sidebarOnChange);
        inputProductList[i].addEventListener("click", sidebarOnClick);
      }
    }
    if (inputCategoryList) {
      for (var i = 0; i < inputCategoryList.length; i++) {
        inputCategoryList[i].addEventListener("change", sidebarOnChange);
        inputCategoryList[i].addEventListener("click", sidebarOnClick);
      }
    }

    // Get Integration List based on Product and Category Selection
    productSelection.addEventListener("change", function(event) {
      event.preventDefault();
      product_slug = productSelection.value;
      if (product_slug == "all") {
        product_slug = null;
      }
      if (product_slug === null) {
        updateURL("", false);
      } else {
        updateURL(product_slug, false);
      }

      getIntegList(product_slug, null);
    });

    // clear product on badge click
    // remove checked value from the active product from the sidebar
    // using event delegation here coz click event is not getting binded on the dynamic contents
    var integTitle = document.querySelector(".integration-title");
    integTitle.addEventListener(
      "click",
      function(e) {
        if (e.target.classList.contains("clear-product-taxonomy")) {
          clearProductTaxonomy(e);
        }
        if (e.target.classList.contains("clear-category-taxonomy")) {
          clearCategoryTaxonomy(e);
        }
      },
      false
    );

    // if the URL has integration value in it
    // eg - browserstack.com/integrations?category=ci-cd&integration=shopify
    if (WPURLS.integration_name) {
      if (WPURLS.integration_name.id) {
        setTimeout(function () {
          // open modal on click
          integModal = initializeModalPopup();

          bsLib.ajax(
            "POST",
            websiteHost + "/wp-admin/admin-ajax.php",
            {
              action: "get_product_integration_content",
              id: WPURLS.integration_name.id
            },
            true, //async
            {
              "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
            }, //request header
            function(data) {
              if (data.readyState === 4) {
                modalAJaxResponseFunc(data, integModal, {
                  id: WPURLS.integration_name.id,
                  name: WPURLS.integration_name.title
                });
              }
            }, //success
            function() {} //error object
          );
        }, 500);
      }
    }

    // when clicking on individual integration Box
    // using event delegation here coz click event is not getting binded on the dynamic contents
    var integrationBox = document.querySelector("#integ-dynamic-html");
    integrationBox.addEventListener("click", integrationBoxClick);
    document
      .querySelector(".popular-list")
      .addEventListener("click", integrationBoxClick);

    //set sidebar height
    sidebar.parentElement.style.height = sidebar.clientHeight + "px";

    // sticky sidebar on contenst scroll
    window.addEventListener("load", integSidebarScroll);
    window.addEventListener("scroll", integSidebarScroll);
    window.addEventListener("resize", integSidebarScroll);
  }

  // On Load WebTracker Event
  function loadIntegratonMainPageFunc() {
    loadWebTrackerEvents.push({
      eventName: 'VisitedIntegrationPage',
      eventProperty: {
        product_filter: WPURLS.product_slug,
        category_filter: WPURLS.category_slug,
      },
    });
  }

  // Visited WebTracker Event
  function mainIntegrationEventFn(eventObj) {
    if (window.hasOwnProperty('WebEventTracker')) {
      WebEventTracker.logEvent(EDS.webEvents, 'InteractedWithIntegrationsPage', eventObj);
    }
  }

  // Define Modal Object with just a default loading icon
  function initializeModalPopup() {
    var integModal = new tingle.modal({
      arialabelledby: "integrationModalTitle",
      ariadescribedby: "integrationModalDesc",
      focusAfterClosed: focusAfterClosed,
      cssClass: ["integration-modal"],
      onClose: function() {
        integModal.destroy();
      }
    });
    integModal.setContent('<p><div class="loading-icon"></div></p>');
    integModal.open();
    return integModal;
  }

  // get current active Product
  // set undefined if value not present
  function getCurrentActiveProduct() {
    var checkedProduct = document.querySelector(
      ".product-list input[name='product-list']:checked"
    );
    return checkedProduct ? checkedProduct.value : undefined;
  }

  // get current active category
  // set undefined if value not present
  function getCurrentActiveCategory() {
    var checkedCategory = document.querySelector(
      ".category-list input[name='category-list']:checked"
    );
    return checkedCategory ? checkedCategory.value : undefined;
  }

  // if clicked on the sidebar options
  function sidebarOnClick() {
    var eventObj = bsLib.extend({
      filter_name: this.getAttribute('value'),
    },
      ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {}
    ));

    if (this.classList.contains("active")) {
      this.classList.remove("active");
      this.checked = false;
      // force an onchange event on an input.
      var event = createNewEvent("change");
      this.dispatchEvent(event);
      eventObj['action'] = 'filter unselected';
    } else {
      if (this.getAttribute("name") == "product-list") {
        // remove active class from all other element
        if (inputProductList) {
          for (var i = 0; i < inputProductList.length; i++) {
            inputProductList[i].classList.remove("active");
          }
        }
      }
      if (this.getAttribute("name") == "category-list") {
        // remove active class from all other element
        if (inputCategoryList) {
          for (var i = 0; i < inputCategoryList.length; i++) {
            inputCategoryList[i].classList.remove("active");
          }
        }
      }
      this.classList.add("active");
      eventObj['action'] = 'filter selected';
    }

    //scroll top and remove sidebar class

    sidebar.classList.remove("fixed");
    sidebar.classList.remove("bottom");

    bsLib.scrollIt(
      document.querySelector(".col-all-integrations").offsetTop - 100,
      200
    );

    product_slug = getCurrentActiveProduct();
    category_slug = getCurrentActiveCategory();

    updateIntegURL(product_slug, category_slug);

    // Product on change js for Amplitude
    if (this.getAttribute('name') == 'product-list') {
      eventObj['type'] = 'product filter';
    } else if (this.getAttribute('name') == 'category-list') {
      eventObj['type'] = 'category filter';
    }

    mainIntegrationEventFn(eventObj);
  }

  // Function to update Query String in the URL
  // https://jsfiddle.net/bp3tmuxh/1/
  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    if (value === undefined) {
      if (uri.match(re)) {
        return uri.replace(re, "$1$2");
      } else {
        return uri;
      }
    } else {
      if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
      } else {
        var hash = "";
        if (uri.indexOf("#") !== -1) {
          hash = uri.replace(/.*#/, "#");
          uri = uri.replace(/#.*/, "");
        }
        var separator = uri.indexOf("?") !== -1 ? "&" : "?";

        //update referrer
        var newReferrer = window.location.href;
        Object.defineProperty(document, "referrer", {
          configurable: true,
          get: function() {
            return newReferrer;
          }
        });

        window.history.pushState(
          { path: WPURLS.currenturl },
          "",
          uri + separator + key + "=" + value + hash
        );
      }
    }
  }

  function updateIntegURL(product_slug, category_slug) {
    if (product_slug && category_slug) {
      var url = updateURL(product_slug, true);
      updateQueryStringParameter(url, "category", category_slug);
    } else if (product_slug && category_slug == null) {
      updateURL(product_slug, false);
    } else if (category_slug && product_slug == null) {
      var url = updateURL("", true);
      updateQueryStringParameter(url, "category", category_slug);
    } else {
      updateURL("", false);
    }
  }

  function getIntegList(product_slug, category_slug) {
    // Display Loader
    var ajaxLoader = document.querySelector(
      ".col-all-integrations .loading-container"
    );

    ajaxLoader.style.display = "block";

    // xhr request for sending form data
    bsLib.ajax(
      "POST",
      websiteHost + "/wp-admin/admin-ajax.php",
      {
        action: "get_product_category_integration",
        product_slug: product_slug,
        category_slug: category_slug
      },
      true, //async
      { "content-type": "application/x-www-form-urlencoded; charset=UTF-8" }, //request header
      function(data) {
        if (data.readyState === 4) {
          var dataRequest = bsLib.JSONParse(data.response);

          ajaxLoader.style.display = "none";
          document.getElementById("integ-title-html").innerHTML =
            dataRequest.title;
          document.getElementById("integ-dynamic-html").innerHTML =
            dataRequest.html;

          // Loop through product counts
          if (dataRequest.product_count) {
            updateIntegrationProductCount(dataRequest.product_count);
          }

          // Loop through categories counts
          if (dataRequest.cat_count) {
            updateIntegrationCategoryCount(dataRequest.cat_count);
          }
        }
      }, //success
      function() {} //error object
    );
    integSidebarScroll();
  }

  function updateIntegrationProductCount(dataArr) {
    Object.keys(dataArr).reduce(function(arr, key) {
      var parentElem = document.getElementById("product-list-" + key).parentElement,
        labelElement = parentElem.querySelector("label");

      if (parentElem) {
        parentElem.querySelector(".product-count").innerHTML = dataArr[key];
        labelElement.ariaLabel = labelElement.dataset.pname + " " + dataArr[key];
      }
      if (dataArr[key] === 0) {
        document.getElementById("product-list-" + key).disabled = true;
        parentElem.querySelector("label").classList.add("disabled");
        parentElem.querySelector("label").tabIndex = -1;
      } else {
        document.getElementById("product-list-" + key).disabled = false;
        parentElem.querySelector("label").classList.remove("disabled");
        parentElem.querySelector("label").tabIndex = 0;
      }
    }, []);
  }

  function updateIntegrationCategoryCount(dataArr) {
    Object.keys(dataArr).reduce(function(arr, key) {
      var parentElem = document.getElementById("category-list-" + key).parentElement,
        labelElement = parentElem.querySelector("label");

      if (parentElem) {
        parentElem.querySelector(".product-count").innerHTML = dataArr[key];
        labelElement.ariaLabel = labelElement.dataset.pname + " " + dataArr[key];
      }
      if (dataArr[key] === 0) {
        document.getElementById("category-list-" + key).disabled = true;
        parentElem.querySelector("label").classList.add("disabled");
        parentElem.querySelector("label").tabIndex = -1;
      } else {
        document.getElementById("category-list-" + key).disabled = false;
        parentElem.querySelector("label").classList.remove("disabled");
        parentElem.querySelector("label").tabIndex = 0;
      }
    }, []);
  }

  function clearProductTaxonomy(e) {
    var filterName = e.target.getAttribute('aria-label'),
      dataProductName = e.target.getAttribute('data-product');
    
    if (inputProductList) {
      for (var i = 0; i < inputProductList.length; i++) {
        if (inputProductList[i].checked == true) {
          inputProductList[i].checked = false;
        }
      }
    }

    // force an onchange event on an input.
    // productSelection.dispatchEvent(event);
    product_slug = getCurrentActiveProduct();
    category_slug = getCurrentActiveCategory();

    var eventObj = bsLib.extend({
      action: filterName,
      filter_name: dataProductName,
      product_filter: product_slug || WPURLS.product_slug,
      category_filter: category_slug || WPURLS.category_slug,
    },
      ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {}
    ));

    mainIntegrationEventFn(eventObj);

    updateIntegURL(product_slug, category_slug); // update dynamic url

    getIntegList(product_slug, category_slug);
  }

  function clearCategoryTaxonomy(e) {
    var filterName = e.target.getAttribute('aria-label'),
      dataProductName = e.target.getAttribute('data-product');
    
    if (inputCategoryList) {
      for (var i = 0; i < inputCategoryList.length; i++) {
        if (inputCategoryList[i].checked == true) {
          inputCategoryList[i].checked = false;
        }
      }
    }
    product_slug = getCurrentActiveProduct();
    category_slug = getCurrentActiveCategory();

    var eventObj = bsLib.extend({
      action: filterName,
      filter_name: dataProductName,
      product_filter: product_slug || WPURLS.product_slug,
      category_filter: category_slug || WPURLS.category_slug,
    },
      ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {}
    ));

    mainIntegrationEventFn(eventObj);

    updateIntegURL(product_slug, category_slug); //update dynamic url
    getIntegList(product_slug, category_slug);
  }

  // if sidebar options gets updated
  function sidebarOnChange(event) {
    event.preventDefault();

    product_slug = getCurrentActiveProduct();
    category_slug = getCurrentActiveCategory();

    getIntegList(product_slug, category_slug);
  }

  // This function updates the URL baased on the selection
  function updateURL(product_slug, returns) {
    if (history.pushState) {
      if (Object.keys(paramsValue).length > 0) {
        queryStringUTM = "?" + Object.keys(paramsValue).map(function(key) {
          return key + '=' + paramsValue[key]
        }).join('&');
      }

      var newurl = WPURLS.currenturl + product_slug + queryStringUTM;
      if (returns) {
        return newurl;
      }

      // update referrer
      // https://mattmazur.com/2018/01/25/bookmarklet-to-manually-set-document-referrer/
      var newReferrer = window.location.href;
      Object.defineProperty(document, "referrer", {
        configurable: true,
        get: function() {
          return newReferrer;
        }
      });
      window.history.pushState({ path: newurl }, "", newurl);
    }
  }

  function integrationBoxClick(e) {
    var integAttrs = {},
      integPaths = e.target.closest(".integration-box");

    if (e.target.closest('.popular-integrations')) {
      integAttrs.category = integPaths ? integPaths.closest('.popular-integrations') ? integPaths.closest('.popular-integrations').querySelector('h2').innerText : '' : '';
    } else {
      integAttrs.category = integPaths ? integPaths.closest('.categories-loop').querySelector('h3') ? integPaths.closest('.categories-loop').querySelector('h3').innerText : integPaths.closest('.all-integrations').querySelector('h2').innerText : '';
    }

    if (
      integPaths &&
      integPaths.className.split(" ").indexOf("integration-box") != -1
    ) {
      integAttrs.id = integPaths.getAttribute("data-id");
      integAttrs.name = integPaths.getAttribute("data-name");
    } else {
      return false;
    }

    var modalExists = document.querySelector('.integration-modal');
    if (modalExists) {
      return false;
    }

    focusAfterClosed = e.target;

    // open modal on click
    integModal = initializeModalPopup();

    bsLib.ajax(
      "POST",
      websiteHost + "/wp-admin/admin-ajax.php",
      {
        action: "get_product_integration_content",
        id: integAttrs.id
      },
      true, //async
      {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
      }, //request header
      function(data) {
        if (data.readyState === 4) {
          modalAJaxResponseFunc(data, integModal, integAttrs);
        }
      }, //success
      function() {} //error object
    );
  }

  function modalAJaxResponseFunc(data, integModal, integAttrs) {
    product_slug = getCurrentActiveProduct();
    category_slug = getCurrentActiveCategory();
    var eventObj = bsLib.extend({
      action: 'integration modal viewed',
      integration_name: integAttrs.name,
      product_filter: product_slug || WPURLS.product_slug,
      category_filter: category_slug || WPURLS.category_slug,
      category: integAttrs.category
    },
      ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {}
    ));

    mainIntegrationEventFn(eventObj);

    integModal.setContent(data.response);

    //Integration CTA
    integrationBoxCta = document.querySelectorAll(".integration-cta a");
    if (integrationBoxCta) {
      var queryStringUTMCTA = "";
      if (Object.keys(paramsValue).length > 0) {
        queryStringUTMCTA = Object.keys(paramsValue).map(function(key) {
          return key + '=' + paramsValue[key]
        }).join('&');
      }

      for (var i = 0; i < integrationBoxCta.length; i++) {
        var currParamsObj,
          curLinkParams = integrationBoxCta[i].href.split("?"),
          curLinkHashParams = integrationBoxCta[i].href.split("#");

        if ( queryStringUTMCTA !== ""
          && integrationBoxCta[i].href.length > 0
          && !(integrationBoxCta[i].href.toLowerCase().indexOf("google_oauth") >= 0
          || integrationBoxCta[i].href.toLowerCase().indexOf("javascript:void") >= 0
          || !(curLinkParams[0].indexOf(".wpengine.com") >= 0
          || curLinkParams[0].indexOf(".browserstack.com") >= 0
          || curLinkParams[0].indexOf(".bsstag.com") >= 0))
          ) {
          
          if (curLinkParams.length > 1) {
            currParamsObj = curLinkParams[1].split('&').map(function (p) { return p.split('='); }).reduce(function (obj, pair) {
              if (pair.length >= 2) {
                //remove whiteListParams from existing link condition 
                if (whiteListParams.indexOf(pair[0]) < 0) {
                  obj[pair[0]] = pair[1];
                }
              }
              return obj;
            }, {});

            if (Object.keys(currParamsObj).length > 0) {
              var currQueryString = Object.keys(currParamsObj).map(function(key) {
                return key + '=' + currParamsObj[key]
              }).join('&');

              integrationBoxCta[i].href = curLinkParams[0] + "?" + currQueryString + "&" + queryStringUTMCTA + (curLinkHashParams.length > 1 ? "#" + curLinkHashParams[1] : "");
            } else {
              integrationBoxCta[i].href = curLinkParams[0] + "?" + queryStringUTMCTA + (curLinkHashParams.length > 1 ? "#" + curLinkHashParams[1] : "");
            }
          } else {
            integrationBoxCta[i].href = curLinkParams[0] + "?" + queryStringUTMCTA + (curLinkHashParams.length > 1 ? "#" + curLinkHashParams[1] : "");
          }

        }

        integrationBoxCta[i].addEventListener(
          'click',
          function (e) {
            var eventObj = bsLib.extend({
              action: 'integration modal CTA clicked',
              integration_name: this.getAttribute('data-name'),
              product_filter: product_slug || WPURLS.product_slug,
              category_filter: category_slug || WPURLS.category_slug,
              category: integAttrs.category,
              cta_name: this.getAttribute('title') || this.innerText,
            },
              ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {}
            ));
        
            mainIntegrationEventFn(eventObj);
          },
          false
        );
      }
    }

    // shopify form validation
    var shopifySubmit = document.querySelector("#shopify-store-submit");
    if (shopifySubmit) {
      shopifySubmit.addEventListener("click", shopifySubmitRedirect);
    }
  }

  /**
   * Shopify Shop Input Integration
   * refs -
   * https://stackoverflow.com/questions/41942690/removing-http-or-http-and-www/41942787
   * https://stackoverflow.com/questions/12175111/validate-accept-only-emails-from-a-specific-domain-name
   *  */
  function shopifySubmitRedirect(event) {
    event.preventDefault();
    var ShopifyShopName = document.getElementById("shopify-store-input").value,
      ShopifyShopInput = document.getElementById("shopify-store-input");
    ShopifyShopName = ShopifyShopName.replace(
      /^(?:https?:\/\/)?(?:www\.)?/i,
      ""
    );
    ShopifyShopName = ShopifyShopName.replace(/\/$/, "");
    var emailError = document.getElementById("email-error");
    if (
      ShopifyShopName.indexOf(
        ".myshopify.com",
        ShopifyShopName.length - ".myshopify.com".length
      ) !== -1
    ) {
      window.location.href =
        "https://browserstack.com/pmtool/shopify/install?shop=" +
        ShopifyShopName;
      ShopifyShopInput.classList.remove("error-border");
      if (emailError) {
        emailError.remove();
      }
    } else {
      inlineError.showError(
        ShopifyShopInput,
        emailError,
        "email-error",
        "Invalid shop domain (eg - example.myshopify.com)"
      );
    }
  }

  function integSidebarScroll() {
    var allIntegNode = document.querySelector(".col-all-integrations"),
      sidebarTopOffset = allIntegNode.offsetTop - 84;
    sidebarBottomPos =
      allIntegNode.offsetTop +
      allIntegNode.offsetHeight -
      sidebar.clientHeight -
      84;

    if (window.pageYOffset >= sidebarBottomPos) {
      sidebar.classList.add("bottom");
    } else if (window.pageYOffset >= sidebarTopOffset) {
      sidebar.classList.add("fixed");
      sidebar.classList.remove("bottom");
    } else {
      sidebar.classList.remove("fixed");
      sidebar.classList.remove("bottom");
    }
  }

  function createNewEvent(eventName) {
    var event;
    if (typeof Event === "function") {
      event = new Event(eventName);
    } else {
      event = document.createEvent("Event");
      event.initEvent(eventName, true, true);
    }
    return event;
  }

  function getClosestElem() {
    //closest Polyfill
    if (window.Element && !Element.prototype.closest) {
      Element.prototype.closest = function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i,
          el = this;
        do {
          i = matches.length;
          while (--i >= 0 && matches.item(i) !== el) {}
        } while (i < 0 && (el = el.parentElement));
        return el;
      };
    }
  }

  init();
};

//integrationJS initialize
integrationsJs();
